module.exports = __webpack_public_path__ + "static/media/file-landscape-alt.032dab09.svg";